<template>
  <div>
    <div v-if="show">
      <v-col cols="12">
        <v-row class="justify-center my-4">
          <h3 class="primary--text">Completar cadastro</h3>
        </v-row>
        <v-row class="justify-center mb-4">
          <v-avatar size="48" color="grey">
            <img v-if="foto !== '#'" :src="foto" alt="name" />
            <img v-else src="../assets/account.svg" alt="name" />
          </v-avatar>
        </v-row>
        <v-form ref="form" v-model="formValid">
          <v-row class="justify-center">
            <v-col cols="12" sm="6">
              <v-row class="mx-2">
                <v-text-field
                  color="primary"
                  v-model="name"
                  :rules="ruleName"
                  label="Nome"
                  @input="validateField('name')"
                ></v-text-field>
              </v-row>
              <v-row class="mx-2 mb-2">
                <v-text-field
                  type="text"
                  v-mask="'(##) #####-####'"
                  hint="Somente números (00) 00000-0000"
                  persistent-hint
                  color="primary"
                  v-model="cel"
                  :rules="ruleCel"
                  label="Celular"
                  @input="validateField('cel')"
                ></v-text-field>
              </v-row>
              <v-row v-if="logado.email" class="justify-center mb-2">
                <strong class="primary--text">{{ logado.email }}</strong>
              </v-row>
              <v-row v-else class="justify-center mx-2">
                <v-text-field
                  v-model="email"
                  :rules="ruleEmail"
                  label="Email"
                  @input="validateField('email')"
                ></v-text-field>
              </v-row>

              <v-row class="align-center">
                <v-checkbox label="Aceito" v-model="aceite" :rules="ruleAceite" @change="validateField('email')"></v-checkbox>
                  <router-link class="mx-4" to="/privacidade" color="primary">Política Privacidade</router-link>
                  <router-link to="/termosdeuso" color="primary">Termos</router-link>
              </v-row>

              <v-row class="justify-center">
                <v-btn
                  outlined
                  :disabled="disabled"
                  color="primary"
                  @click="atualizar()"
                  >{{ fazer }}</v-btn
                >
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </div>
    <div v-else>
      <v-row style="height: 80vh" class="justify-center align-center">
        <v-progress-circular
          :size="60"
          :width="8"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </v-row>
    </div>

    <!-- <v-snackbar v-model="alert" multi-line color="accent" :timeout="-1">
      {{ msg }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="alert = false">
          fechar
        </v-btn>
      </template>
    </v-snackbar> -->
  </div>
</template>

<script>
export default {
  name: "cadastro-complete",
  computed: {
    error() {
      return this.$store.getters.error;
    },
    user() {
      return this.$store.getters.user;
    },
    logado() {
      return this.$store.getters.logado;
    },
  },
  watch: {
    error(e) {
      console.log(e);
      if (this.$route.path !== "/") {
        this.$router.push("/");
      }
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.user === undefined) {
        this.fazer = "salvar";
        this.name = this.logado.nome || "";
        this.cel = this.logado.cel || "";
        this.foto = this.logado.foto || "#";
        this.show = true;
      } else {
        if (this.$route.path !== "/") {
          this.$router.push("/");
        }
      }
    }, 1000);
  },
  data() {
    return {
      msg: "",
      alert: false,
      aceite: false,
      show: false,
      disabled: true,
      loading: false,
      name: "",
      cel: "",
      foto: "",
      fazer: "",
      email: "",
      formValid: false,
      ruleName: [
        (value) => !!value || "Obrigatório.",
        (value) => value.length >= 10 || "Míx. 10 caracteres.",
        (value) => !!value || "Obrigatório.",
        (value) => value.length <= 30 || "Max. 30 caracteres.",
      ],
      ruleCel: [
        (value) => !!value || "Obrigatório.",
        (value) => value.length === 15 || "Celular inválido.",
      ],
      ruleEmail: [
          value => !!value || 'Obrigatório.',
          value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'E-mail inválido';
        }
      ],
      ruleAceite: [
        (value) => !!value,
      ],
    };
  },
  methods: {
    dataHora() {
      const date = new Date().toLocaleDateString("pt-BR");
      const hora = new Date().toLocaleTimeString("pt-BR");
      return date + " " + hora;
    },
    atualizar() {
      this.logging = true;
      this.disabled = true;

      if (this.fazer === "salvar") {
        let obj = {
          uid: this.logado.uid,
          email: this.logado.email || this.email,
          foto: this.logado.foto || "",
          cel: this.cel,
          nome: this.name,
          aceite: this.dataHora(),
          tabdef: 1,
          novo: true
        };
        this.$store.dispatch("insertUser", obj);
        this.$store.dispatch("loadUser", obj.uid);
      } else {
        let obj = this.user;
        obj.cel = this.cel;
        obj.nome = this.name;
        obj.aceite = this.dataHora()
        this.$store.dispatch("updateUser", obj);
        this.$store.dispatch("loadUser", obj.uid);
      }
      const erro = this.error;
      if (erro === undefined) {
        this.showAlert();
      }
      this.$store.dispatch("loadProdutos");
      this.$store.dispatch("loadPrecosCm2");
      this.$store.dispatch("loadImagens");
      this.$router.push("/");
    },
    validateField() {
      const valid = this.$refs.form.validate();
      if (valid) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    showAlert() {
      this.msg = "Alguma coisa deu errado! Verifique seus dados e sua conexão.";
      this.alert = true;
    },
  },
};
</script>
